import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import { createPinia } from 'pinia'

const app = createApp(App)
app.use(ElementPlus)
app.use(router)
app.use(createPinia())
app.mount('#app')
const resizeObserverErr = 'ResizeObserver loop completed with undelivered notifications.'
const originalErrorHandler = window.onerror

window.onerror = function(message, source, lineno, colno, error) {
  if (message.includes(resizeObserverErr)) {
    return true // 忽略此错误
  }
  return originalErrorHandler && originalErrorHandler(message, source, lineno, colno, error)
}